export default __webpack_public_path__ + "static/media/eb-blk-1.74fc4237.png";